"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es/object/assign");
require("core-js/es/object/entries");
require("core-js/es/array/from");
require("core-js/web/url-search-params");
require("core-js/es/promise");
require("custom-event-polyfill");
require("xcssmatrix");
var React = require("react");
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var ReactDOM = require("react-dom");
var Detail_1 = require("@/pages/detail/components/Detail");
var redux_1 = require("redux");
var redux_saga_1 = require("redux-saga");
var RootDetailSaga_1 = require("@/pages/detail/sagas/RootDetailSaga");
var RootDetailReducer_1 = require("@/pages/detail/reducers/RootDetailReducer");
var callAllSaga_1 = require("@/rendering/common/callAllSaga");
var getAllState_1 = require("@/utils/getAllState");
if (typeof window !== 'undefined') {
    var stateFromServer = window.REDUX_DATA;
    var rootView = function (store) { return (React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(react_intl_1.IntlProvider, { locale: "en" },
            React.createElement(Detail_1.default, null)))); };
    var sagaMiddleware = redux_saga_1.default();
    var rootStore = redux_1.createStore(RootDetailReducer_1.default, redux_1.applyMiddleware(sagaMiddleware));
    window.REDUX = rootStore;
    if (stateFromServer) {
        var setAllStateSymbol = getAllState_1.getAllState(stateFromServer.page);
        rootStore.dispatch({ type: setAllStateSymbol, payload: stateFromServer });
    }
    sagaMiddleware.run(callAllSaga_1.callAllSaga(RootDetailSaga_1.rootDetailSagas));
    ReactDOM.render(rootView(rootStore), document.getElementById('app'));
}
